export default __webpack_public_path__ + "2fd09691d042e43e5609bdbb9b360b99.png";